import {api} from '~/ViewInvitation/api/api';
import {PHOTO_API_TAGS} from '~/ViewInvitation/api/photos';

const getPhotosQuery = ({eventId, guestId, perPage, includeCount = false}) => {
  const queryParams = new URLSearchParams();
  if (perPage) queryParams.append('per_page', perPage || 3);
  if (guestId) queryParams.append('guest_id', guestId);
  if (includeCount) queryParams.append('include_count', `${includeCount}`);
  const queryString = queryParams.toString();
  const queryStringParams = queryString && `?${queryString}`;
  return {
    url: `/ajax/event/${eventId}/posts/photos${queryStringParams}`,
  };
};

const getHostPhotosQuery = ({eventId, perPage, includeCount = false}) => {
  const queryParams = new URLSearchParams();
  if (perPage) queryParams.append('page_size', perPage || 10);
  if (includeCount) queryParams.append('include_count', `${includeCount}`);
  const queryString = queryParams.toString();
  const queryStringParams = queryString && `?${queryString}`;
  return {
    url: `/ajax/event/${eventId}/host-gallery${queryStringParams}`,
  };
};

export const photosApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // Shared Photo Queries
    getPhotos: builder.query({
      query: getPhotosQuery,
      providesTags: [PHOTO_API_TAGS.SHARED],
    }),
    deletePhotos: builder.mutation({
      query: ({id, guestId, eventId}) => ({
        url: `/ajax/event/${eventId}/posts/${id}/?gid=${guestId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [PHOTO_API_TAGS.SHARED],
    }),
    postPhotos: builder.mutation({
      query: ({photos, eventId, guestId}) => ({
        url: `/ajax/event/${eventId}/posts/photos/?gid=${guestId}`,
        method: 'POST',
        body: {
          // biome-ignore lint/style/useNamingConvention: existing error
          photo_ids: photos,
        },
      }),
    }),
    // Host Photo Queries
    getHostPhotos: builder.query({
      query: getHostPhotosQuery,
      providesTags: [PHOTO_API_TAGS.HOST],
    }),
    deleteHostPhotos: builder.mutation({
      query: ({eventId, ids}) => ({
        url: `/ajax/event/${eventId}/host-gallery/`,
        method: 'DELETE',
        body: {
          ids,
        },
      }),
      invalidatesTags: [PHOTO_API_TAGS.HOST],
    }),
    postHostPhotos: builder.mutation({
      query: ({photos, title, eventId}) => ({
        url: `/ajax/event/${eventId}/host-gallery/`,
        method: 'PUT',
        body: {
          photos,
          title,
        },
      }),
      invalidatesTags: [PHOTO_API_TAGS.HOST],
    }),
  }),
});

export const {
  // Shared Photo Queries
  useGetPhotosQuery,
  useLazyGetPhotosQuery,
  useDeletePhotosMutation,
  usePostPhotosMutation,
  // Host Photo Queries
  useGetHostPhotosQuery,
  useDeleteHostPhotosMutation,
  usePostHostPhotosMutation,
} = photosApi;
